<template>
  <div class="query-main" style="width:550px;margin-top:6px;">
    <div class="query-box">
      <ul class="qu-tab-tilte" style="margin-left:-6px;">
        <li @click="tabChange(0)" :class="{ active: activea == 0 }">
          <span style="left:28px;">新机构公示信息</span>
        </li>
        <li @click="tabChange(1)" :class="{ active: activea == 1 }">
          <span style="left:38px;">全省机构信息</span>
        </li>
      </ul>
      <div class="scroll-boxsd" v-if="activea == 0" style="margin-top:-38px;">
        <!-- <div v-if="this.resource.length > 0"> -->
          <dv-scroll-board
            :rowNum="12"
            :config="configdisplacementofDam"
            style="width: 100%; height: 480px"
          />
        <!-- </div> -->
        <!-- <div v-else>
          <img src="../assets/img/zw.png" alt="" />
        </div> -->
      </div>
      <div class="scroll-boxsd" v-if="activea == 1" style="margin-top:-38px;">
        <!-- <div v-if="this.resource.length > 0"> -->
          <dv-scroll-board
            :rowNum="12"
            :config="configdisplacementofDam1"
            style="width: 100%; height: 480px"
            @click="toDetail"
          />
        <!-- </div>
        <div v-else>
          <img src="../assets/img/zw.png" alt="" />
        </div> -->
      </div>
    </div>
    <cModal :show="modal">
      <div class="modalBox">
        <div class="headerWrap">
          <p class="head_left">综合评分：86</p>
          <p class="head_right" @click="closeModal">
            <img src="../assets/img/whiteCloseIcon.png" alt="" />
          </p>
        </div>
        <div class="con">
          <div class="con_li" v-for="(it, idx) in evaData" :key="idx">
            <p class="con_li_title">{{ it.title }}:</p>
            <div class="con_li_star">
              <img
                src="../assets/img/starSelect.png"
                alt=""
                v-for="item in 4"
                :key="item"
              />
              <img src="../assets/img/star.png" alt="" />
            </div>
            <p class="con_li_score">平均分数: 86</p>
          </div>
        </div>
      </div>
    </cModal>
  </div>
</template>

<script>
import { GetTongGuo } from "@/api/news";
import cModal from "../components/cModal.vue";
export default {
  components: {
    cModal
  },
  data() {
    return {
      activea: 0,
      resource: [],
      datadisplacementofDam: [],
      datadisplacementofDam1: [],
      configdisplacementofDam: {},
      configdisplacementofDam1: {},
      // headerdisplacementofDam: [ '省份','市','单位名称', '单位地址','状态'],
      headerdisplacementofDam: ["市", "单位名称", "单位地址"],
      headerdisplacementofDam1: ["市", "单位名称", "单位地址", "单位电话"],
      detailInfo: {},
      modal: false,
      evaData: [
        {
          title: "硬件环境"
        },
        {
          title: "培训质量"
        },
        {
          title: "收费标准"
        },
        {
          title: "师资力量"
        },
        {
          title: "服务态度"
        }
      ]
    };
  },
  created() {
    this.gundong()
    this.tabChange(1);
  },
  methods: {
    gundong(){
      GetTongGuo({type:this.activea}).then(res => {
        this.resource = res.data
        this.tabChange(0)
      })
    },
    tabChange(val) {
      this.activea = val;
      if (this.activea == 0) {
        GetTongGuo({ type: 1 }).then(res => {
          this.resource = res.data;
          var arr = {};
          this.datadisplacementofDam = [];
          this.resource.forEach(item => {
            arr.ProvinceName = item.ProvinceName;
            // arr.CityName=item.CityName
            arr.Name = item.Name;
            arr.Address = item.Address;
            // arr.IsAudit=item.IsAudit
            this.datadisplacementofDam.push(arr);
            arr = {};
          });
          this.configdisplacementofDam = {
            data: this.datadisplacementofDam, // 表数据
            // data:res.data,
            header: this.headerdisplacementofDam, // 表头数据
            rowNum: 11, // 表行数
            headerBGC: "#F5F3F4", // 表头背景色
            oddRowBGC: "#f2f2f7", // 奇数行背景色
            evenRowBGC: "#f8d9da", // 偶数行背景色
            waitTime: 3000, // 轮播时间间隔(ms)
            align: "center"
          };
        });
      }
      if (this.activea == 1) {
        GetTongGuo({ type: 0 }).then(res => {
          this.resource = res.data;
          var arr = {};
          this.datadisplacementofDam1 = [];
          this.resource.forEach(item => {
            // arr.ProvinceName=item.ProvinceName
            arr.CityName = item.CityName;
            arr.Name = item.Name;
            arr.Address = item.Address;
            arr.Phone = item.PhoneNum;
            // arr.IsAudit=item.IsAudit
            this.datadisplacementofDam1.push(arr);
            arr = {};
          });
          this.configdisplacementofDam1 = {
            data: this.datadisplacementofDam1, // 表数据
            // data:res.data,
            header: this.headerdisplacementofDam1, // 表头数据
            rowNum: 11, // 表行数
            headerBGC: "#F5F3F4", // 表头背景色
            oddRowBGC: "#f2f2f7", // 奇数行背景色
            evenRowBGC: "#f8d9da", // 偶数行背景色
            waitTime: 3000, // 轮播时间间隔(ms)
            align: "center"
          };
        });
      }
    },
    toDetail(val) {
      // console.log('val',val);
      this.detailInfo = val.row;
      this.modal = true;
    },
    closeModal() {
      this.modal = false;
    }
  }
};
</script>

<style lang="less" scoped>
// 3B3C43
/deep/.dv-scroll-board .header .header-item {
  color: #3b3c43;
}
.modalBox {
  width: 490px;
  height: 366px;
  background-color: #fff;
  border-radius: 10px;
}
.headerWrap {
  width: 100%;
  height: 60px;
  border-radius: 10px 10px 0px 0px;
  background-color: #c3242c;
  padding: 0px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .head_left {
    font-size: 22px;
    color: #fff;
  }
  .head_right {
    img {
      width: 26px;
      cursor: pointer;
    }
  }
}
.con {
  width: 430px;
  margin: auto;
  .con_li {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 26px;
    .con_li_title {
      font-size: 20px;
      color: #3e3d44;
      // font-weight: bold;
    }
    .con_li_star {
      width: 200px;
      display: flex;
      justify-content: space-between;
      margin-top: 0px;
      img {
        width: 24px;
        height: 24px;
      }
    }
    .con_li_score {
      font-size: 18px;
      color: #f76933;
    }
  }
}
// .query-main .qu-tab-tilte li.active{
//   background-size:110% 100%;
// }
.query-main .qu-tab-tilte li {
  width: 240px;
  background-position: -13px -9px;
}
.query-main .qu-tab-tilte li.active {
  background-position: -13px -9px;
}
</style>



// WEBPACK FOOTER //
// src/components/organInfo.vue